module.exports = __webpack_public_path__ + "static/media/Car_project.3b8c15a4.jpg";